import React from 'react';
import FixedView from '../FixedView';
import moment from 'moment';
// import Calender from './calender';
import { checkTranslation, getObject, translate } from '../../utils/useful';
import TableViewer from '../TableViewer';


export default class Week extends React.Component {
    constructor(props) {
        super(props)
        this.firstView = React.createRef();
        this.firstCurrentNode = React.createRef();
        this.yearCurrentNode = React.createRef();
        this.yearCurrentNode = React.createRef();

        this.state = {
            // calender: new Calender(),
            // activeDay: null,
            // key: 'TEpyxZL1neC2JBZViuDaJ'
        }
    }

    componentDidMount() {
        this.setState({ data: this.props.data }, () => {
            // console.log('maincla', this.state.data)
        })
    }
    showMonthList = () => {
        // console.log("DDD")
        this.firstView.showView()
    }
    showYearList = () => {
        this.yearView.showView()
    }

    selectDay = (day) => {
        // let newDate = moment.utc();
        // newDate.set('year', year);
        // newDate.set('month', month - 1);
        // newDate.set('date', day);
        // this.setState({ activeDay: [newDate.format('YYYY MM DD'), { day, month, year }] }, () => {
        this.props.currentCalendar?.setActiveDay(day)

        // this.setState({ activeDay: day }, () => {
        //     this.changeData()
        // })
    }

    changeData = () => {
        let showData = this.props.data
        let key = this.state.key
        if (showData) {
            showData = showData.filter(cdata => moment(cdata?.values[key]).format('YYYY-MM-DD') === this.state.activeDay?.key)
        }
        this.setState({ showData })
    }


    actionClicked = (prop, data, index) => {
        this.props.functionsHandler('collection', prop, data, index)
    }






    render() {
        const calender = this.props.currentCalendar;
        const week = calender?.getWeek();
        let data = []
        // console.log('calender.activeDay?.key',calender.activeDay?.key)
        // console.log('this.props.daysData',this.props.daysData)
        if (this.props.daysData && this.props.daysData[calender.activeDay?.key]) {
            data = this.props.daysData[calender.activeDay.key]
        }
        // else if (!this.props.daysData) {
        //     data = this.props.data

        // }


        // console.log(calender.activeDay?.key)
        // console.log(this.props.daysData)
        // console.log(data)

        // const rToday = calender?.getToday();
        // let cToday = { year: calender?.toMoment().format('YYYY'), month: calender?.toMoment().format('MM'), day: 0 } // calenderToday

        // console.log(this.props.data)
        return (
            <div className='' style={{ direction: 'ltr' }}>



                {/* <div style={{}} className="d-flex justify-content-between pb-2 pt-3 px-3">

                        <div className="d-flex align-content-center ">
                            <button onClick={() => this.showMonthList()} ref={el => this.firstCurrentNode = el} >
                                <p className='text-center font-size-20' style={{ minWidth: 85 }}>{calender?.toMoment().format('MMMM')}</p>
                            </button>
                            <p className='text-center px-2 font-size-15' onClick={() => this.showYearList()} ref={el => this.yearCurrentNode = el} style={{}}>{calender?.toMoment().format('YYYY')}</p>

                            <button className='mt-1' onClick={() => { calender?.goToPrev('month'); this.setState({ calender }) }}>
                                <img src="/assets/icons/chevron.backward-gray.svg" width={17} alt='back' className=" btn-hover1" style={{ cursor: "pointer" }} />
                                <img style={{ cursor: "pointer" }} width={18} className="" src="/assets/icons/dot.png" />
                            </button>

                            <button className='mt-1' onClick={() => { calender?.goToNext('month'); this.setState({ calender }) }}>
                                <img className=" btn-hover1" src="/assets/icons/chevron.forward-gray.svg" alt='next' width={17} style={{ cursor: "pointer" }} />
                            </button>

                        </div>
                    </div>
                    <FixedView ref={el => this.firstView = el} nodeRef={this.firstCurrentNode} showFocus={false} topOffset={20} xOffset={0} zIndex={10} width={300}>
                        <div className='month-list flexc flex-wrap py-2 px-2'>
                            {MonthsName.map((month, index) => {
                                return (
                                    <button onClick={() => { calender?.setMonth(index + 1); this.setState({ calender, }) }} className='text-start px-2 py-1 note-hover-box2 br-5' style={{ width: '33.3%' }}>
                                        <p className='text-small text-semibold'>{checkTranslation(month)}</p>
                                    </button>
                                )
                            })}
                        </div>
                    </FixedView >
                    <FixedView ref={el => this.yearView = el} nodeRef={this.yearCurrentNode} showFocus={false} topOffset={20} xOffset={0} zIndex={10} width={300}>
                        <div className='month-list py-2 px-2'>
                            <p className='text-small text-bold text-center mb-2 mt-1'>{translate("Select Year")}</p>
                            <div className='flexc flex-wrap '>
                                {YearsName.map((year, index) => {
                                    return (
                                        <button onClick={() => { calender?.setYear(year); this.setState({ calender }) }} className='text-center px-2 py-1 note-hover-box2 br-5' style={{ width: '33.3%' }}>
                                            <p className='text-small text-semibold'>{year}</p>
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    </FixedView> */}
                <div style={{ background: '#fff', position: 'sticky', top: 0, }}>

                    <div className="" style={{ background: "#fff", borderBottom: '1px solid #f0f0f0' }}>
                        <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                            {/* <button onClick={() => { calender?.goToPrev('week'); this.setState({ calender }) }}>
                                <img src="/assets/icons/arrowtriangle.left.circle.fill.svg" alt='back' style={{ opacity: "50%" }} />
                            </button> */}

                            {week?.map((day, index) => {
                                // cToday.day = day
                                // let activeDay = this.state.activeDay
                                // const isSelected = activeDay ? (cToday.year === activeDay[1].year) && (cToday.day === activeDay[1].day) && (cToday.month === activeDay[1].month) : (cToday.year === rToday.year) && (cToday.day === rToday.day) && (cToday.month === rToday.month);
                                const isSelected = calender.activeDay?.key == day.key
                                const isToday = calender.today?.key == day.key

                                return (
                                    <div className='flex-1' style={{ borderRight: '0px solid #eee', }}>
                                        <button onDragOver={this.handleDragOver} onDrop={(event) => this.handleDrop(event, day)} onClick={() => this.selectDay(day)} style={{ alignItems: 'center', background: isSelected ? 'rgb(86, 84, 214)' : (isToday ? 'rgba(86, 84, 214,0.1)' : 'transparent'), borderRadius: 2, width: '100%' }}>
                                            {/* {console.log(isSelected, "is today")} */}
                                            <div className='flexcc flex-column' style={{ padding: 5 }}>

                                                <div className='' style={{ paddingTop: 2 }}>
                                                    <p className='text-smaller text-semibold opacity-5' style={{ color: isSelected ? '#fff' : '#000' }}>{checkTranslation(calender.weekDayNames[index])}</p>
                                                </div>
                                                <div className='mrd-1'>
                                                    <p className='text-normal text-semibold' style={{ color: isSelected ? '#fff' : '#000' }}>{checkTranslation(day.day)}</p>
                                                </div>


                                            </div>
                                        </button>
                                    </div>
                                )
                            })}

                            {/* <button onClick={() => { calender?.goToNext('week'); this.setState({ calender }) }}>
                                <img src="/assets/icons/arrowtriangle.right.circle.fill.svg" alt='next' style={{ opacity: "50%" }} />
                            </button> */}
                        </div>
                    </div>
                </div>
                <div className='w-100'>

                    {data?.length > 0 && (
                        <div className="h-100 w-100  " style={{ background: '#FFF' }}>
                            {/* {data?.map((prop, index) => {
                                let keyText = this.props.view?.settings?.stacked?.viewKey
                                let value = getObject(prop, keyText)
                                return (
                                    <div onClick={() => this.actionClicked('openEditModal', prop, index)} draggable id={prop._id} key={prop._id} onDragStart={(event) => this.handleDragStart(event, prop)} className='p-3 m-2' style={{ background: 'rgba(86, 84, 214,0.08)', color: 'rgba(86, 84, 214,1)', borderRadius: '8px' }} >
                                        <p> {value}</p>
                                    </div>
                                )
                            })} */}
                            {/* {console.log('this.props.headers',this.props.headers)} */}
                            <TableViewer
                                headers={this.props.headers}
                                data={data}
                                actions={this.props.actions}
                                page={this.props.page}
                                permissions={this.props.permissions}
                                functionsHandler={this.props.functionsHandler}
                                // actions={this.state.actions}
                                ref={el => this.TableViewer = el}
                            />


                        </div>
                    )}
                    {(data?.length == 0) && (
                        <div className='w-100 flexcc py-4'>
                            <p>{translate("No Data")}</p>
                        </div>
                    )}

                </div>

            </div >
        )
    }
    handleDragStart = (event, prop) => {
        this.setState({ draggedItem: prop })
        let i = document.getElementById(prop._id)
        event.dataTransfer.setDragImage(i, 0, 0);
    };
    handleDragOver = (event) => {
        event.preventDefault();
    };

    handleDrop = (event, day) => {
        let str = `${day.year} ${day.month} ${day.day}`
        const momentDate = moment(str, 'YYYY MM DD');
        const timestamp = momentDate.valueOf();
        let data = this.state.data
        let key = this.state.key
        data.forEach((item) => {
            if (item._id == this.state.draggedItem._id) {
                item.values[key] = timestamp
            }
        })
        let item = this.state.draggedItem
        item.values[key] = timestamp
        this.setState({ data }, () => {
            this.changeData()
        })
        this.props.submitForm(item, true)

        this.setState({
            draggedItem: null,
        })

    };
}